__turbopack_context__.v({
  "navbar": "navbar-module-DNV5JNPN-module__9lAvrG__navbar",
  "navbarBrand": "navbar-module-DNV5JNPN-module__9lAvrG__navbarBrand",
  "navbarContent": "navbar-module-DNV5JNPN-module__9lAvrG__navbarContent",
  "navbarMenu": "navbar-module-DNV5JNPN-module__9lAvrG__navbarMenu",
  "navbarMenuIcon": "navbar-module-DNV5JNPN-module__9lAvrG__navbarMenuIcon",
  "navbarSubmenu": "navbar-module-DNV5JNPN-module__9lAvrG__navbarSubmenu",
  "navbarSubmenuCheckbox": "navbar-module-DNV5JNPN-module__9lAvrG__navbarSubmenuCheckbox",
});
